import React from 'react';

const queryContext = React.createContext({});

export default queryContext
